/*
 *
 * UploadCameraMedia constants
 *
 */

export const FLUSH_STATE = 'app/containers/UploadCameraMedia/FLUSH_STATE';

export const CHANGE_DATA = 'app/containers/UploadCameraMedia/CHANGE_DATA';

export const UPLOAD_MEDIA_FILE =
  'app/containers/UploadCameraMedia/UPLOAD_MEDIA_FILE';
export const UPLOAD_MEDIA_FILE_SUCCESS =
  'app/containers/UploadCameraMedia/UPLOAD_MEDIA_FILE_SUCCESS';
export const UPLOAD_MEDIA_FILE_ERROR =
  'app/containers/UploadCameraMedia/UPLOAD_MEDIA_FILE_ERROR';
